"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRouter = exports.default = exports.RouterContext = exports.Previous = exports.Next = exports.Current = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _main = _interopRequireDefault(require("../app/main"));
var _router = _interopRequireDefault(require("../../services/core/router"));
var _core = require("../../services/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react-hooks/exhaustive-deps */

// provider app

// Core

const RouterContext = exports.RouterContext = /*#__PURE__*/_react.default.createContext();
const Current = exports.Current = 'current';
const Previous = exports.Previous = 'previous';
const Next = exports.Next = 'next';

//-------------------------
// NE PAS TOUCHER
// SI UNE ERREUR SURVIENT,
// PREVENIR VIA LE CHANNEL OU MAIL
//-------------------------

/**
 * Permet de changer les valeurs courante du reducer.
 *
 * @author Dimitri Houssin
 * @version 1.0.0
 */
const historyReducer = (state, action) => {
  // Ceci est important, il faut pouvoir faire une nouvelle copie de state,
  // sinon le composant ne s'actualise pas.
  const newState = {
    ...state
  };
  switch (action.type) {
    case Current:
      newState.previous = newState.current;
      newState.current = action.value;
      newState.next = null;
      _core._Logger.info('Router', 'change current', newState);
      return newState;
    case Previous:
      newState.next = newState.current;
      newState.current = newState.previous;
      newState.previous = null;
      return newState;
    case Next:
      newState.previous = newState.current;
      newState.current = newState.next;
      newState.next = null;
      return newState;
    default:
      return state;
  }
};

/**
 * Permet de changer de page.
 */
const RouterProvider = _ref => {
  let {
    propsContext
  } = _ref;
  // reducer / context
  const [history, dispatch] = (0, _react.useReducer)(historyReducer, {
    current: null,
    previous: null,
    next: null
  });

  // Change la page courante.
  const changeCurrent = component => {
    dispatch({
      type: Current,
      value: component
    });
  };

  /**
   * Affiche la page voulue pour la clé fournie en paramètre
   *
   * @param {string} key
   */
  const displayView = key => {
    const app = _router.default._get(key);
    if (!app) {
      _core._Notifications.error((0, _core._translate)('Router'), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', (0, _core._translate)('Cannot access page :'), "` $", key, "`"));
      return;
    }
    changeCurrent(app);
  };

  /**
   * Va sur la page précédente : previous => current ; current => next, previous => null
   */
  const goToPrevious = () => {
    dispatch({
      type: Previous,
      value: null
    });
  };

  /**
   * Va sur la page suivante : make next => current ; current => previous, next => null
   */
  const goToNext = () => {
    dispatch({
      type: Next,
      value: null
    });
  };

  // initilisation, sur main.
  (0, _react.useEffect)(() => {
    displayView('main');
  }, []);
  return /*#__PURE__*/_react.default.createElement(RouterContext.Provider, {
    value: {
      display: displayView,
      previous: goToPrevious,
      next: goToNext,
      history
    }
  }, /*#__PURE__*/_react.default.createElement(_main.default, propsContext, history.current));
};
const useRouter = () => (0, _react.useContext)(RouterContext);
exports.useRouter = useRouter;
RouterProvider.propTypes = {
  propsContext: _propTypes.default.oneOfType([_propTypes.default.any])
};
RouterProvider.defaultProps = {
  propsContext: null
};
var _default = exports.default = RouterProvider;